import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ fullHeight?: boolean }>()(
  (theme, { fullHeight }) => ({
    mainContainer: {
      height: fullHeight ? '90vh' : 'calc(100vh - 250px)',
      maxHeight: fullHeight ? '88vh' : theme.spacing(99.5),
      width: '100%',
      backgroundColor: theme.palette.stages.default,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      gap: theme.spacing(2),
      borderRadius: theme.spacing(1),
    },
    noDataImage: {
      maxWidth: theme.spacing(26.75),
      height: theme.spacing(9.75),
    },
    description: {
      color: theme.palette.labraText.description,
      fontFamily: 'Poppins',
      fontSize: '14px',
      lineHeight: '20px',
    },
  })
)
